<template>
  <b-modal size="md" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <b-container>
      <b-form @submit.stop.prevent="salvar">
        <b-row>
          <b-col>
            <LgFormConstSelect id="tipo" label="Tipo Endereço Eletrônico:*" v-model="form.tipoEnderecoEletronico"
              :options="tiposEndereco" required></LgFormConstSelect>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <LgFormInput id="descricao" label="Endereço:*" v-model="form.descricao" required></LgFormInput>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group class="col-12" label="Endereço Principal:" label-for="principal">
              <b-form-checkbox id="principal" v-model="form.principal" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group class="col-12" label="Status:*" label-for="status">

              <b-form-radio-group id="status" size="sm" v-model="form.situacao" :options="options"
                name="situacao-options" class="col-12 d-flex form-group" />
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-center mt-3">
          <b-button id="salvarEnderecoEletronico" type="submit" variant="success" style="height: 30px" pill size="sm">
            <div class="btn-size-alinhamento">
              <b-icon icon="check-circle" />
            </div>
            <b-tooltip target="salvarEnderecoEletronico" title="Salvar" triggers="hover"></b-tooltip>

          </b-button>
          <b-button id="cancelarEnderecoEletronico" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm" variant="danger">
            <div class="btn-size-alinhamento">
              <b-icon icon="x-circle" />
            </div>
            <b-tooltip target="cancelarEnderecoEletronico" title="Cancelar" triggers="hover"></b-tooltip>

          </b-button>
        </div>
      </b-form>
    </b-container>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import API from "@/core/api/index";
import ResourceService from "@/core/api/ResourceService";

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
  },
  props: {
    prefix: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      default: null,
    },
    codEmpresa: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showModal: true,
      form: {
        descricao: "",
        tipoEnderecoEletronico: null,
        situacao: 1,
        principal: false,
        codEmpresa: this.codEmpresa,
      },
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      tiposEndereco: [],
    };
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/endereco-eletronico`);
    API.get(`/api/endereco-eletronico/tipos`).then((response) => {
      this.tiposEndereco = [
        { text: "Selecione...", value: null },
        ...response.data.map((item) => ({
          text: item.descricao,
          value: item,
        })),
      ];
    });

    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
      this.form.codEmpresa = this.codEmpresa;
    }
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Cadastro"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    cancelar() {
      this.$emit("fechar");
    },
    async salvar() {
      if (!this.form.tipoEnderecoEletronico) {
        this.$notify({
          type: "danger",
          message: `Preencha o campo de tipo`,
        });
        return;
      }
      if (!this.form.descricao) {
        this.$notify({
          type: "danger",
          message: `Preencha o campo de endereço`,
        });
        return;
      }
      try {
        await this.$service.save(this.form);
        this.$emit("fechar");
      } catch (error) {
        console.error("Erro ao adicionar endereço eletrônico:", error);
      }
    },
  },
};
</script>

<style scoped>
.btn-size-alinhamento {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
